<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card> 
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
              Firms Management
          </v-toolbar-title>
          <v-spacer></v-spacer>  
          <v-card-actions class="justify-center">
            <v-btn 
              @click.stop="dialog = true"
              outlined
              large>
              <v-icon left color='teal'>
                add
              </v-icon>
              NEW FIRM
            </v-btn>
          </v-card-actions>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link>   -->
        </v-toolbar>
        
        <v-card> 
          <template v-for="(item, index) in getFirms">
            <!-- <v-divider :key="index+1 + firmCount"></v-divider> -->
            <v-divider :key="item['.key']"></v-divider>
            <v-card :key="index">
              <v-card-title class="body-1 primary--text font-weight-light" col>
                <v-flex xs5>
                  Firm Name: &nbsp; <b class="font-weight-bold">{{item.name}}</b>   
                  <v-spacer/>
                  Proprietor Name: &nbsp; <b class="font-weight-bold">{{item.proprietor}}</b> 
                  <v-spacer/>
                  Mobile Number: &nbsp; <b class="font-weight-bold">{{item.mobileNumber}}</b>
                  <v-spacer/>
                  Address: &nbsp; <b class="font-weight-bold">
                    {{ item.liveAddress}} <br/>
                    {{ item.tehsil || '-' }} - {{item.district || '-'}} - {{item.state || '-'}}</b> 
                  <v-spacer/>
                  Email: &nbsp; <b class="font-weight-bold">{{item.email || '-'}}</b>
                  <!-- <v-spacer/>
                  Website: &nbsp; <b class="font-weight-bold">{{ item.website || '-'}}</b> -->
                </v-flex>
                <v-flex xs1>
                  </v-flex>
                <v-flex xs5>
                  GST Number: &nbsp; <b class="font-weight-bold">{{item.GST_number}}</b> 
                  <v-spacer/>
                  Pan Number: &nbsp; <b class="font-weight-bold">{{item.panNumber}}</b> 
                  <v-spacer/>
                  Opening Balance of Capital A/C: &nbsp; <b class="font-weight-bold">{{item.openingBalance || 0 | amount}}</b> 
                  <v-spacer/>
                  Opening Balance of Stock: &nbsp; <b class="font-weight-bold">{{item.openingStock || 0 | amount}}</b> 
                  <v-spacer/>
                  Opening Balance Cash A/C: &nbsp; <b class="font-weight-bold">{{item.openingCashAmount || 0 | amount}}</b> 
                  <v-spacer/>
                  Cash In Hand: &nbsp; <b class="font-weight-bold">{{item.amount || 0 | amount}}</b> 
                </v-flex> 
                <v-flex xs1>  
                  <v-btn flat icon class="primary white--text" @click="editFirm(item)">
                    <v-icon primary title class="white--text">edit</v-icon>
                  </v-btn>
                </v-flex> 
              </v-card-title>
              
              <!-- <v-card-actions> -->
                <!-- <v-btn flat icon class="primary white--text" @click="editFirm(item)">
                  <v-icon primary title class="white--text">edit</v-icon>
                </v-btn>   -->
                <!-- <v-btn flat icon class="primary white--text" @click="deletefirm(item['.key'])">
                  <v-icon>delete</v-icon>
                </v-btn> -->
              <!-- </v-card-actions> -->
            </v-card>
          </template>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
      >
        {{ text }}
      </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="900">
      <v-card>
        <v-card-title  primary title class="primary white--text">
           <span class="headline">Add New Firm</span> 
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-flex xs4 sm4 md4>
              <v-text-field label="Firm Name" v-model="firmName" ></v-text-field>
              <v-text-field label="Proprietor Name" v-model="firmProprietor" ></v-text-field>
              <v-menu :close-on-content-click="false"
                  v-model="datepicker1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="firmOpeningDate"
                    label="Opening Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="firmOpeningDate" @input="datepicker1 = false"></v-date-picker>
                </v-menu>
              <v-text-field label="Opening Balance of Capital A/C" v-model="firmOpeningBalance" ></v-text-field>
              <v-text-field label="Opening Stock Balance" v-model="firmOpeningStock" ></v-text-field>
              <!-- <v-text-field label="Opening Cash Account Balance" v-model="amount.value" ></v-text-field> -->
              <v-checkbox v-model="switch2" label="Opening Balance of Cash Account"></v-checkbox>
              <v-text-field ref="openingCashAmount" v-if="switch2" label="Enter opening Balance of Cash Account" v-model="openingCashAmount.value" :rules="openingCashAmount.rules" ></v-text-field>
              <v-checkbox v-model="switch1" label="Cash Account"></v-checkbox>
              <v-text-field ref="amount" v-if="switch1" label="Enter amount" v-model="amount.value" :rules="amount.rules" ></v-text-field>
            </v-flex>

            <v-flex xs1 sm1 md1>
            </v-flex>

            <v-flex xs3 sm3 md3>
              <v-text-field label="Mobile Number" :rules="firmMobileNumber.rules" v-model="firmMobileNumber.value" ></v-text-field>
              <v-text-field type="number" @change="setLocationBasedOnZipCode()" ref="zipCode" v-model="zipCode" label="ZipCode"></v-text-field>
              <v-text-field label="Address" v-model="firmLiveAddress" ></v-text-field>
              <v-select v-if="zipCode" v-model="country.value" :items="gCountry" label="Country"></v-select>
              <v-select v-if="country.value" v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
              <v-select v-if="state.value" v-model="district.value" :items="gDistrict" label="District"></v-select>
              <v-select v-if="district.value" v-model="tehsil.value" :items="gTehsil"  label="Tehsil" clearable></v-select>
              <v-select v-if="tehsil.value" v-model="block.value" :items="gBlock"  label="Block" clearable></v-select>
              <v-select v-if="block.value" v-model="village.value" :items="gVillage"  label="Village" clearable></v-select>                           
            </v-flex>

            <v-flex xs1 sm1 md1>
            </v-flex>

            <v-flex xs3 sm3 md3>
              <v-select v-model="GST_user" :items="['Yes','No']" label="GST User"></v-select>

              <v-text-field 
                v-if="GST_user === 'Yes'"
                type="text" 
                :disabled="GST_user != 'Yes'" 
                v-model="GST_number.value" 
                :rules="GST_number.rules" 
                label="GST number">
              </v-text-field>
              <v-select
                v-if="GST_user === 'Yes'"
                v-model="GST_Type.value"
                :disabled="GST_user != 'Yes'"
                :items="gGST_Type"
                label="GST Scheme"
              ></v-select>
              <v-text-field v-if="GST_user === 'No' " label="Registration(TIN) Number " v-model="firmRegNumber" ></v-text-field>
              <v-text-field 
                label="PAN Number" 
                :rules="PAN_Rules" 
                v-model="panNumber" >
              </v-text-field>
              <v-text-field ref="email" type="email" v-model="email.value" :rules="email.rules" label="Email"></v-text-field>
              <v-text-field ref="website" v-model="website" label="Website"></v-text-field>
              <v-select
                v-model="businessType"
                :items="['Automobile/Agriculture/Spare Parts', 'Clothes', 'Default', 'Dairy', 'Jwellery', 'Medical/Pesticides', 'Grain', 'Restaurant']"
                label="Business Type"
                placeholder="Select Business Type"
              ></v-select>
              <p style="color: red;font-style: italic;font-size: 12px;"> Note: This field can't be edited in future.</p>
            </v-flex>
            
            
           </v-layout>
          </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="addNewFirm">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent max-width="900">
      <v-card>
        <v-form ref="editAccount" v-model="addNewFirmValid" lazy-validation>
          <v-card-title primary title class="primary white--text">
           <span class="headline">Edit Firm</span> 
          </v-card-title>
          <v-card-text>
            <v-layout row>
            <v-flex xs4 sm4 md4>
              <v-text-field label="Firm Name" v-model="firmNameEdit" ></v-text-field>
              <v-text-field label="Proprietor Name" v-model="firmProprietorEdit" ></v-text-field>
              <v-menu :close-on-content-click="false"
                  v model="datepicker  "
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="firmOpeningDateEdit"
                    label="Opening Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="firmOpeningDateEdit" @input="datepicker2 = false"></v-date-picker>
                </v-menu>
              <v-text-field label="Edit Opening Balance of Capital Account" v-model="firmOpeningBalanceEdit" ></v-text-field>
              <v-text-field label="Edit Opening Stock Balance" v-model="firmOpeningStockEdit" ></v-text-field>
              <!-- <v-text-field label="Edit Cash Account Balance" v-model="amountEdit.value" ></v-text-field> -->
              <v-checkbox v-model="switch2Edit" label="Edit Opening Balance of Cash Account"></v-checkbox>
              <v-text-field ref="openingCashAmountEdit" v-if="switch2Edit" label="Enter Opening Balance" v-model="openingCashAmountEdit.value" :rules="openingCashAmountEdit.rules" ></v-text-field>  
              <v-checkbox v-model="switch1Edit" label="Edit Cash Account Balance"></v-checkbox>
              <v-text-field ref="amount" v-if="switch1Edit" label="Enter amount" v-model="amountEdit.value" :rules="amountEdit.rules" ></v-text-field>   
            </v-flex>

            <v-flex xs1 sm1 md1>
            </v-flex>  
            
            <v-flex xs3 sm3 md3>
              <v-text-field label="Mobile Number" :rules="firmMobileNumberEdit.rules" v-model="firmMobileNumberEdit.value" ></v-text-field>
              <v-text-field type="number" @change="setLocationBasedOnZipCode()" ref="zipCode" v-model="zipCode" label="ZipCode"></v-text-field>
              <v-text-field label="Address" v-model="firmLiveAddressEdit" ></v-text-field>
              <v-select v-if="zipCode" v-model="country.value" :items="gCountry" label="Country"></v-select>
              <v-select v-if="country.value" v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
              <v-select v-if="state.value" v-model="district.value" :items="gDistrict" label="District"></v-select>
              <v-select v-if="district.value" v-model="tehsil.value" :items="gTehsil" clearable label="Tehsil"></v-select>
              <v-select v-if="tehsil.value" v-model="block.value" :items="gBlock"  label="Block" clearable></v-select>
              <v-select v-if="block.value" v-model="village.value" :items="gVillage"  label="Village" clearable></v-select>                           
              
              <!-- <v-select v-model="GST_user" :items="['Yes','No']" label="GST User"></v-select>

              <v-select v-if="zipCode" v-model="village.value" :items="gVillage"  label="Village"></v-select>
            
              <v-select v-if="zipCode" v-model="block.value" :items="gBlock"  label="Block"></v-select>
            
              <v-select v-if="zipCode" v-model="tehsil.value" :items="gTehsil"  label="Tehsil"></v-select>

              <v-select v-if="zipCode" v-model="district.value" :items="gDistrict" label="District"></v-select>
            
              <v-select v-if="zipCode" v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
            
              <v-select v-if="zipCode" v-model="country.value" :items="gCountry" label="Country"></v-select> -->
            </v-flex>

            <v-flex xs1 sm1 md1>
            </v-flex>

            <v-flex xs3 sm3 md3>
              <v-select v-model="GST_user" :items="['Yes','No']" label="GST User"></v-select>
              <v-text-field 
                v-if="GST_user === 'Yes'"
                type="text" 
                :disabled="GST_user != 'Yes'" 
                :rules="GST_number.rules" 
                v-model="GST_number.value" 
                label="GST number">
              </v-text-field>
              <v-select
                v-if="GST_user === 'Yes'"
                v-model="GST_Type.value"
                :disabled="GST_user != 'Yes'"
                :items="gGST_Type"
                label="GST Type"
              ></v-select>
              <v-text-field  
                v-if="GST_user === 'No'" 
                label="Registration Number" 
                v-model="firmRegNumberEdit" >
              </v-text-field>
              <v-text-field label="PAN Number" :rules="PAN_Rules" v-model="panNumber" ></v-text-field>
              <v-text-field type="email" ref="email" v-model="email.value" :rules="email.rules" label="Email"></v-text-field>
              <v-text-field ref="website" v-model="website" label="Website"></v-text-field>
              <v-select
                v-model="businessType"
                :disabled="!!businessType"
                :items="['Automobile/Agricluture/Spare Parts', 'Clothes', 'Default', 'Dairy', 'Jwellery', 'Medical/Pesticides', 'Grain']"
                label="Business Type"
              ></v-select>
              <p v-if="!businessType" style="color: red;font-style: italic;font-size: 12px;"> Note: This field can't be edited in future.</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="cancelDialogEdit">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="updateFirm">
            Update
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import axios from 'axios';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Firms',
  data () {
    return {
      businessType:null,
      dialogEdit : false,
      dialog: false,
      addNewFirmValid: false,
      firmName: null,
      firmProprietor:null,
      firmLiveAddress: null,
      firmLiveAddressEdit: null,
      firmRegNumber:null,
      panNumber:null,
      GST_user:null,
      website:null,
      timeout:3000,
      snackbar:false,
      zipCode : null,
      datepicker1: false,
      datepicker2: false,
      text:null,
      amount:{
        value:0,
      },
      openingCashAmount:{
        value:0,
      },
      switch1: false,
      switch2: false,
      firmMobileNumber: {
        value: null,
        rules: [
          v => !!v || 'Mobile is required',
            v => /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
        ]
      },
      firms: [],
      GST_Type: {
        value : null
      },
      firmNameEdit:null,
      firmProprietorEdit:null,
      firmRegNumberEdit:null,
      firmMobileNumberEdit: {
        value: null,
        rules: [
          v => !!v || 'Mobile is required',
            v => /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
        ]
      },
      amountEdit:{
        value:0,
        // rules:[
        //   v => !!v || 'Amount is Required',
        //   v => v>0 || 'Amount cannot be negative'
        // ]
      },
      openingCashAmountEdit:{
        value:0,
        // rules:[
        //   v => !!v || 'Amount is Required',
        //   v => v>0 || 'Amount cannot be negative'
        // ]
      },
       GST_number: {
        value: '',
        rules: [
          v => {
            let obj = this.gState.find(o => o.state === this.state.value);
            let reg = /^$/;
            if (obj && obj.code) {
              reg = new RegExp("^(["+obj.code+"]){2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}");
            }
            return (
              v == undefined ||
              /^$/.test(v) ||
              reg.test(v) ||
              "GST number must be Valid"
            );
          }
        ]
      },
      PAN_Rules: [
        v => {
            let obj = this.gState.find(o => o.state === this.state.value);
            let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
            return (
              v == undefined ||
              /^$/.test(v) ||
              reg.test(v) ||
              "PAN number must be Valid"
            );
          }
      ],
      email : {
        value: '',
        //  rules: [
        //   v =>  /^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
        // ],
      },
      switch1Edit: false,
      switch2Edit: false,
      firmOpeningBalance:null,
      firmOpeningDate: new Date().toISOString().substr(0, 10),
      firmOpeningBalanceEdit:null,
      firmOpeningDateEdit:null,
      firmOpeningStock:null,
      firmOpeningStockEdit:null,
      updateKey:null,
      village: {
        value: ''
      },
      block: {
        value: ''
      },
      tehsil: {
        value: ''
      },
      district: {
        value: ''
      },
      state: {
        value: ''
      },
      country: {
        value: ''
      },
    }
  },
  created () {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    this.$bindAsArray("operator", this.$root.$firebaseRefs.operator);
    let today = new Date()
    this.date = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    this.firmOpeningDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    this.firmOpeningDateEdit = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
     ...mapGlobalGetters({
      gVillage: 'village',
      gBlock: 'block',
      gTehsil: 'tehsil',
      gDistrict: 'district',
      gState: 'state',
      gCountry: 'country',
      gGST_Type: 'GST_Type'
    }),
    getFirms () {
      if (this.firms && this.selectedBrand) {
        return this.firms.filter(item => item['brand'] === this.selectedBrand)
      }
    },
    firmCount () {
      return this.getFirms.length || 0
    },
  },
  methods: {
    setLocationBasedOnZipCode(){
      let reg = /^[1-9][0-9]{5}$/;
       console.log(this.zipCode)
      if(this.zipCode && reg.test(this.zipCode)) {
          console.log("change")
           axios
          .get('https://api.postalpincode.in/pincode/'+this.zipCode)
          .then(response => {
            let data = response.data[0].PostOffice[0];
            this.gCountry.push(data.Country);
            this.gState.push(data.State);
            this.gDistrict.push(data.District);
            this.gTehsil.push(data.Block);
            setTimeout(() => {
              this.country.value = data.Country;
              this.state.value = data.State;
              this.district.value = data.District;
              this.tehsil.value = data.Block;
            }, 100);
          })
      }
    },
    addNewFirm () {
      if (this.firmName && this.selectedBrand) {
        let data = {
          brand: this.selectedBrand,
          name: this.firmName,
          proprietor:this.firmProprietor,
          liveAddress: this.firmLiveAddress,
          registrationNumber:this.firmRegNumber,
          mobileNumber:Number(this.firmMobileNumber.value),
          openingBalance:Number(this.firmOpeningBalance),
          openingStock:Number(this.firmOpeningStock),
          openingDate : new Date(this.firmOpeningDate).getTime(),
          amount:Number(this.amount.value),
          openingCashAmount:Number(this.openingCashAmount.value),
          amountAtCreation:Number(this.amount.value),
          village: this.village.value,
          block: this.block.value,
          tehsil: this.tehsil.value,
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          website: this.website,
          panNumber: this.panNumber,
          email: this.email.value,
          GST_user : this.GST_user,
          GST_number : this.GST_number.value,
          GST_Type : this.GST_Type.value,
          zipCode : this.zipCode,
          businessType : this.businessType
        };
        if(this.switch1){
          if(this.amount){
            data['amount']= Number(this.amount.value)
            this.$root.$firebaseRefs.firm.push(data);
            // this.addInvoice();
            this.firmName= null;
            this.firmProprietor= null;
            this.firmLiveAddress = null;
            this.firmRegNumber= null;
            this.firmMobileNumber.value= null;
            this.firmOpeningBalance= null;
            this.firmOpeningStock= null;
            this.firmOpeningDate = null;
            this.switch1=false;
            this.switch2=false;
            this.amount.value = 0;
            this.openingCashAmount.value = 0;
            this.dialog=false;
            this.village.value = null;
            this.block.value = null;
            this.tehsil.value = null;
            this.district.value = null;
            this.state.value = null;
            this.country.value = null;
            this.email.value = null;
            this.website = null;
            this.GST_user = null;
            this.GST_number.value=null;
            this.panNumber = null;
            this.GST_Type.value = null;
            this.zipCode = null;
            this.businessType = null;
          }else{
            this.snackbar=true;
            this.text= "Please fill the amount"
          }
        }else{
          this.$root.$firebaseRefs.firm.push(data)
          this.dialog=false;
          this.firmName= null;
          this.firmProprietor= null;
          this.firmRegNumber= null;
          this.firmMobileNumber.value= null;
          this.firmOpeningBalance= null;
          this.firmOpeningStock= null;
          this.firmOpeningDate = null;
          this.switch1=false;
          this.switch2=false;
          this.amount.value = 0;
          this.openingCashAmount.value = 0;
          this.village.value = null;
          this.block.value = null;
          this.tehsil.value = null;
          this.district.value = null;
          this.state.value = null;
          this.country.value = null;
          this.email.value = null;
          this.website = null;
          this.GST_user = null;
          this.GST_number.value=null;
          this.panNumber = null;
          this.zipCode = null;
          this.GST_Type.value = null;
          this.businessType = null;
        }
      }
    },

    //Start of Bydefault fetchinng values
    // getAndSetDefaultValues() {
    //   let operatorArr = this.operator.filter(
    //     item => item["brand"] === this.selectedBrand
    //   );
    //   let operator = operatorArr[0];
    //   if(operator){
    //     if(!this.village.value && operator.village){
    //     this.village.value = operator.village;
    //     }
    //     if(!this.block.value && operator.block){
    //       this.block.value = operator.block;
    //     }
    //     if(!this.tehsil.value && operator.tehsil){
    //       this.tehsil.value = operator.tehsil;
    //     }
    //     if(!this.district.value && operator.district){
    //       this.district.value = operator.district;
    //     }
    //     if(!this.state.value && operator.state){
    //       this.state.value = operator.state;
    //     }
    //     if(!this.country.value && operator.country){
    //       this.country.value = operator.country;
    //     }
    //     if(!this.email.value && operator.email){
    //       this.email.value = operator.email;
    //     }
    //   }
    // },
    // End of Bydefault Fetching Values


    // addInvoice(){
    //   let invoiceData = {
    //       brand: this.selectedBrand,
    //       type:'automatic invoice',
    //       paymentType:'cash',
    //       subtype:'deposit',
    //       isCredited:true,
    //       totalAmount:Number(this.amount.value),
    //       date:Date.now()
    //   }
    //   this.$root.$firebaseRefs.invoice.push(invoiceData);
    // },
    deletefirm(key){
      this.$root.$firebaseRefs.firm.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
      this.firmName= null;
      this.firmProprietor= null;
      this.firmLiveAddress = null;
      this.firmRegNumber= null;
      this.firmMobileNumber.value= null;
      this.firmOpeningBalance= null;
      this.firmOpeningStock= null;
      this.firmOpeningDate = null;
      this.amount = 0;
      this.openingCashAmount = 0;
      this.switch1=false;
      this.switch2=false;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
      this.email.value = null;
      this.zipCode = null;
      this.website = null;
      this.GST_user = null;
      this.GST_number.value=null;
      this.panNumber = null;
      this.GST_Type.value = null;
      this.businessType = null;
    },
    cancelDialogEdit(){
      this.dialogEdit = false;
      this.firmNameEdit= null;
      this.firmProprietorEdit= null;
      this.firmLiveAddressEdit = null;
      this.firmRegNumberEdit= null;
      this.firmMobileNumberEdit.value= null;
      this.firmOpeningBalanceEdit= null;
      this.firmOpeningStockEdit= null;
      this.firmOpeningDateEdit = null;
      this.amountEdit.value = 0;
      this.openingCashAmountEdit.value = 0;
      this.switch1Edit=false;
      this.switch2Edit=false;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
      this.email.value = null;
      this.website = null;
      this.GST_user = null;
      this.GST_number.value=null;
      this.panNumber = null;
      this.zipCode = null;
      this.GST_Type.value = null;
      this.businessType = null;
    },
    editFirm(key){
      this.dialogEdit=true;
      console.log(key)
      this.firmNameEdit=key.name;
      this.firmProprietorEdit=key.proprietor;
      this.firmLiveAddressEdit=key.liveAddress;
      this.firmRegNumberEdit=key.registrationNumber ? key.registrationNumber : null;
      this.firmMobileNumberEdit.value=key.mobileNumber;
      this.firmOpeningBalanceEdit=isNaN(key.openingBalance) ? 0 : key.openingBalance;
      this.firmOpeningStockEdit=isNaN(key.openingStock) ? 0 : key.openingStock;
      this.firmOpeningDateEdit =  key.openingDate ? new Date(key.openingDate).toISOString().substr(0, 10) : null,
      this.village.value = key.village;
      this.block.value = key.block;
      this.tehsil.value = key.tehsil;
      this.district.value = key.district;
      this.state.value = key.state;
      this.country.value = key.country;
      this.email.value = key.email;
      this.website = key.website;
      this.GST_user = key.GST_user;
      this.GST_number.value= key.GST_number;
      this.panNumber = key.panNumber;
      this.updateKey  = key['.key'];
      this.GST_Type.value = key.GST_Type;
      this.zipCode = key.zipCode;
      this.businessType = key.businessType;
      if(key.amount > 0){
        this.switch1Edit=true;
        this.amountEdit.value=isNaN(key.amount) ? 0 : Number.parseFloat(key.amount);
      }else{
        this.switch1Edit=false
      };
      if(key.openingCashAmountEdit > 0){
        this.switch2Edit=true;
        this.openingCashAmountEdit.value=isNaN(key.openingCashAmountEdit) ? 0 : Number.parseFloat(key.openingCashAmountEdit);
      }else{
        this.switch2Edit=false
      }
    },
    updateFirm(){
      if (this.firmNameEdit && this.selectedBrand) {
        let data = {
          brand: this.selectedBrand,
          name: this.firmNameEdit,
          proprietor:this.firmProprietorEdit,
          liveAddress:this.firmLiveAddressEdit,
          registrationNumber:this.firmRegNumberEdit  ? this.firmRegNumberEdit : null,
          mobileNumber:Number(this.firmMobileNumberEdit.value),
          openingBalance:Number(this.firmOpeningBalanceEdit),
          openingStock:Number(this.firmOpeningStockEdit),
          openingDate:new Date(this.firmOpeningDateEdit).toISOString().substr(0, 10),
          amount:Number(this.amountEdit.value),
          openingCashAmount:Number(this.openingCashAmountEdit.value),
          zipCode: this.zipCode,
          village: this.village.value,
          block: this.block.value,
          tehsil: this.tehsil.value,
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          website: this.website,
          panNumber: this.panNumber,
          email: this.email.value,
          GST_user : this.GST_user,
          GST_number : this.GST_number.value,
          GST_Type : this.GST_Type.value,
          businessType : this.businessType
        };
        if(this.switch1Edit || this.switch2Edit){
          if(this.amountEdit || this.openingCashAmountEdit){
            data['amount']= Number(this.amountEdit.value) || Number(this.openingCashAmountEdit.value)
            let updatedData = {
              brand: this.selectedBrand,
              name: this.firmNameEdit,
              proprietor:this.firmProprietorEdit,
              liveAddress: this.firmLiveAddressEdit,
              registrationNumber:this.firmRegNumberEdit  ? this.firmRegNumberEdit : null,
              mobileNumber:Number(this.firmMobileNumberEdit.value),
              openingBalance:Number(this.firmOpeningBalanceEdit),
              openingStock:Number(this.firmOpeningStockEdit),
              openingDate:new Date(this.firmOpeningDateEdit).toISOString().substr(0, 10),
              amount:Number(this.amountEdit.value),
              openingCashAmount: Number(this.openingCashAmountEdit.value),
              zipCode: this.zipCode,
            };
  
            if(this.village.value)
            updatedData['village'] = this.village.value;

            if(this.block.value)
            updatedData['block'] = this.block.value;

            if(this.tehsil.value)
            updatedData['tehsil'] = this.tehsil.value;

            if(this.district.value)
            updatedData['district'] = this.district.value;
            
            if(this.state.value)
            updatedData['state'] = this.state.value;
            
            if(this.country.value)
            updatedData['country'] = this.country.value;

            if(this.email.value)
            updatedData['email'] = this.email.value;

            if(this.GST_number.value)
            updatedData['GST_number'] = this.GST_number.value;

            if(this.panNumber)
            updatedData['panNumber'] = this.panNumber;

            if(this.website)
            updatedData['website'] = this.website;

            if(this.GST_user)
            updatedData['GST_user'] = this.GST_user;

            if(this.GST_Type.value)
            updatedData['GST_Type'] = this.GST_Type.value;

            if(this.businessType)
            updatedData['businessType'] = this.businessType;

            this.$root.$firebaseRefs.firm.child(this.updateKey).update(updatedData);
            this.firmNameEdit= null;
            this.firmProprietorEdit= null;
            this.firmLiveAddressEdit= null;
            this.firmRegNumberEdit= null;
            this.firmMobileNumberEdit.value= null;
            this.firmOpeningBalanceEdit= null;
            this.firmOpeningStockEdit = null;
            this.firmOpeningDateEdit = null;
            this.switch1Edit=false;
            this.switch2Edit=false;
            this.amountEdit.value = 0;
            this.openingCashAmountEdit.value = 0;
            this.zipCode = null;
            this.dialogEdit=false;
            this.switch1Edit=false;
            this.village.value = null;
            this.block.value = null;
            this.tehsil.value = null;
            this.district.value = null;
            this.state.value = null;
            this.country.value = null;
            this.email.value = null;
            this.website = null;
            this.GST_user = null;
            this.GST_number.value=null;
            this.panNumber = null;
            this.GST_Type.value = null;
            this.businessType = null;
          }else{
            this.snackbar=true;
            this.text= "Please fill the amount"
          }
        }else{
          let updatedData = {
            brand: this.selectedBrand,
            name: this.firmNameEdit,
            proprietor:this.firmProprietorEdit,
            liveAddress: this.firmLiveAddressEdit,
            registrationNumber:this.firmRegNumberEdit,
            mobileNumber:Number(this.firmMobileNumberEdit.value),
            openingBalance:Number(this.firmOpeningBalanceEdit),
            openingStock:Number(this.firmOpeningStockEdit),
            openingDate:new Date(this.firmOpeningDateEdit).getTime(),
            amount:Number(this.amountEdit.value),
            openingCashAmount: Number(this.openingCashAmountEdit.value),
            zipCode:this.zipCode
          }

          if(this.village.value)
          updatedData['village'] = this.village.value;

          if(this.block.value)
          updatedData['block'] = this.block.value;

          if(this.tehsil.value)
          updatedData['tehsil'] = this.tehsil.value;

          if(this.district.value)
          updatedData['district'] = this.district.value;
          
          if(this.state.value)
          updatedData['state'] = this.state.value;
          
          if(this.country.value)
          updatedData['country'] = this.country.value;

          if(this.email.value)
          updatedData['email'] = this.email.value;

          if(this.GST_number.value)
          updatedData['GST_number'] = this.GST_number.value;

          if(this.panNumber)
          updatedData['panNumber'] = this.panNumber;

          if(this.website)
          updatedData['website'] = this.website;

          if(this.GST_user)
          updatedData['GST_user'] = this.GST_user;

          if(this.GST_Type.value)
          updatedData['GST_Type'] = this.GST_Type.value;

           if(this.businessType)
          updatedData['businessType'] = this.businessType;

          this.$root.$firebaseRefs.firm.child(this.updateKey).update(updatedData);
          this.firmNameEdit= null;
          this.firmProprietorEdit= null;
          this.firmLiveAddressEdit= null;
          this.firmRegNumberEdit= null;
          this.firmMobileNumberEdit.value= null;
          this.firmOpeningBalanceEdit= null;
          this.firmOpeningStockEdit= null;
          this.firmOpeningDateEdit = null;
          this.switch1Edit=false;
          this.amountEdit.value = 0;
          this.switch2Edit=false;
          this.openingCashAmountEdit.value = 0;
          this.zipCode = null;
          this.dialogEdit=false;
          this.village.value = null;
          this.block.value = null;
          this.tehsil.value = null;
          this.district.value = null;
          this.state.value = null;
          this.country.value = null;
          this.email.value = null;
          this.website = null;
          this.GST_user = null;
          this.GST_number.value=null;
          this.panNumber = null;
          this.GST_Type.value = null;
          this.businessType = null;
        }
      }
    }
  },
  watch: {
    selectedBrand() {
      // this.getAndSetDefaultValues();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Firms/index.vue